module.exports = __webpack_public_path__ + "img/3.63534b01.png";